<template>
  <div>
    <v-text-field
      v-model="cboCategoryName"
      :label="label"
      :append-icon="dropdownCategory ? 'expand_less' : 'expand_more'"
      @click="dropdownCategory = !dropdownCategory"
      @click:append="dropdownCategory = !dropdownCategory"
      :readonly="true"
      required
    ></v-text-field>
    <v-dialog v-model="dropdownCategory" max-width="800">
      <v-list class="pa-3">
        <div v-for="category in categories" :key="category.categoryId">
          <v-list-group
            no-action
            :value="category.isCurrent"
            v-if="category.childs && category.childs.length === 0"
          >
            <v-list-tile slot="activator" @click="selectCategory(category.categoryId)">
              <v-list-tile-title :class="(category.isCurrent === true ? 'red--text ' : '') + 'noselect'">{{ category.name }} <v-icon v-if="category.status === 'hidden'" small class="ml-1 red--text">visibility_off</v-icon></v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-list-group
            no-action
            :value="category.isCurrent"
            v-else-if="category.childs && category.childs.length > 0"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title :class="(category.isCurrent === true ? 'red--text ' : '') + 'noselect'">{{ category.name }} <v-icon v-if="category.status === 'hidden'" small class="ml-1 red--text">visibility_off</v-icon></v-list-tile-title>
            </v-list-tile>
            <div v-for="child in category.childs" :key="child.categoryId">
              <v-list-group
                class="level-2"
                sub-group
                no-action
                :value="child.isCurrent"
                v-if="child.childs && child.childs.length > 0"
              >
                <v-list-tile slot="activator">
                  <v-list-tile-title :class="(child.isCurrent === true ? 'red--text ' : '') + 'noselect'">{{ child.name }} <v-icon v-if="child.status === 'hidden'" small class="ml-1 red--text">visibility_off</v-icon></v-list-tile-title>
                </v-list-tile>
                <div v-for="grandChild in child.childs" :key="grandChild.categoryId">
                  <v-list-group
                    class="level-3"
                    sub-group
                    no-action
                    :value="grandChild.isCurrent"
                    v-if="grandChild.childs && grandChild.childs.length > 0"
                  >
                    <v-list-tile slot="activator">
                      <v-list-tile-title :class="(grandChild.isCurrent === true ? 'red--text ' : '') + 'noselect'">{{ grandChild.name }} <v-icon v-if="grandChild.status === 'hidden'" small class="ml-1 red--text">visibility_off</v-icon></v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-for="greatGrandChild in grandChild.childs" :key="greatGrandChild.categoryId" @click="selectCategory(greatGrandChild.categoryId)">
                      <v-list-tile-title :class="(greatGrandChild.isCurrent === true ? 'red--text font-weight-bold ' : '') + 'noselect'">{{ greatGrandChild.name }} <v-icon v-if="greatGrandChild.status === 'hidden'" small class="ml-1 red--text">visibility_off</v-icon></v-list-tile-title>
                    </v-list-tile>
                  </v-list-group>
                  <v-list-tile v-else @click="selectCategory(grandChild.categoryId)">
                    <v-list-tile-title :class="(grandChild.isCurrent === true ? 'red--text font-weight-bold ' : '') + 'noselect'">{{ grandChild.name }} <v-icon v-if="grandChild.status === 'hidden'" small class="ml-1 red--text">visibility_off</v-icon></v-list-tile-title>
                  </v-list-tile>
                </div>
              </v-list-group>
              <v-list-tile v-else @click="selectCategory(child.categoryId)">
                <v-list-tile-title :class="(child.isCurrent === true ? 'red--text font-weight-bold ' : '') + 'noselect'">{{ child.name }} <v-icon v-if="child.status === 'hidden'" small class="ml-1 red--text">visibility_off</v-icon></v-list-tile-title>
              </v-list-tile>
            </div>
          </v-list-group>
          <v-list-tile v-else @click="selectCategory(category.categoryId)">
            <v-list-tile-title :class="(category.isCurrent === true ? 'red--text font-weight-bold ' : '') + 'noselect'">{{ category.name }} <v-icon v-if="category.status === 'hidden'" small class="ml-1 red--text">visibility_off</v-icon></v-list-tile-title>
          </v-list-tile>
        </div>
      </v-list>
    </v-dialog>
  </div>
</template>

<style scoped>

.v-list__tile__title {
  font-size: 14px;
}
.v-list__tile {
  height: 44px;
}

.level-2 >>> .v-list__group__items {
  margin-left: 25px;
}

.level-3 >>> .v-list__group__items {
  margin-left: 30px;
}

</style>

<script>
import { EventBus } from '../main'

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false,
      default: 'category'
    },
    categoryArray: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    blank: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      categories: [],
      dropdownCategory: false,
      cboCategoryName: ''
    }
  },
  created () {
    var _this = this
    EventBus.$on('categoryListLoaded', categories => {
      var newCategories = []
      if (_this.blank) {
        newCategories = [{
          name: '-',
          categoryId: '',
          childs: [],
          level: 0,
          parentId: ''
        }]
      }
      newCategories = newCategories.concat(_this.deepCopy(categories))
      _this.categories = newCategories

      // format categories
      newCategories = _this.resetCategories(newCategories)
      var rst = _this.markCategories(newCategories, _this.value)
      _this.categories = _this.deepCopy(rst.categories)
      _this.cboCategoryName = rst.displayName
    })
  },
  mounted () {
    if (this.categoryArray.length > 0) {
      var newCategories = []
      if (this.blank) {
        newCategories = [{
          name: '-',
          categoryId: '',
          childs: [],
          level: 0,
          parentId: ''
        }]
      }
      newCategories = newCategories.concat(this.deepCopy(this.categoryArray))
      this.categories = newCategories

      // format categories
      newCategories = this.resetCategories(newCategories)
      var rst = this.markCategories(newCategories, this.value)
      this.categories = this.deepCopy(rst.categories)
      this.cboCategoryName = rst.displayName
    }
  },
  watch: {
    // enable to sync between pc and mobile layout (if using different component)
    value (newValue, oldValue) {
      console.log('value changed from ' + oldValue + ' to ' + newValue)
      if (newValue !== oldValue) {
        this.selectCategory(newValue)
      }
    }
  },
  methods: {
    selectCategory: function (selectedCategoryId) {
      var rst = this.markCategories(this.resetCategories(this.categories), selectedCategoryId)
      this.categories = this.deepCopy(rst.categories)
      this.cboCategoryName = rst.displayName
      this.dropdownCategory = false

      // update v-model
      this.$emit('input', selectedCategoryId)
    },
    resetCategories: function (categories) {
      var i, j, k, l
      for (i in categories) {
        categories[i].isCurrent = false
        for (j in categories[i].childs) {
          categories[i].childs[j].isCurrent = false
          for (k in categories[i].childs[j].childs) {
            categories[i].childs[j].childs[k].isCurrent = false
            for (l in categories[i].childs[j].childs[k].childs) {
              categories[i].childs[j].childs[k].childs[l].isCurrent = false
            }
          }
        }
      }
      return categories
    },
    markCategories: function (categories, currentCategoryId) {
      var isFound = false
      var displayName = ''
      var i, j, k, l

      for (i in categories) {
        if (categories[i].categoryId === currentCategoryId) {
          categories[i].isCurrent = true
          displayName = categories[i].name
          isFound = true
          break
        }

        for (j in categories[i].childs) {
          if (categories[i].childs[j].categoryId === currentCategoryId) {
            categories[i].isCurrent = true
            categories[i].childs[j].isCurrent = true
            displayName = categories[i].name + ' > ' + categories[i].childs[j].name
            isFound = true
            break
          }

          for (k in categories[i].childs[j].childs) {
            if (categories[i].childs[j].childs[k].categoryId === currentCategoryId) {
              categories[i].isCurrent = true
              categories[i].childs[j].isCurrent = true
              categories[i].childs[j].childs[k].isCurrent = true
              displayName = categories[i].name + ' > ' + categories[i].childs[j].name + ' > ' + categories[i].childs[j].childs[k].name
              isFound = true
              break
            }

            for (l in categories[i].childs[j].childs[k].childs) {
              if (categories[i].childs[j].childs[k].childs[l].categoryId === currentCategoryId) {
                categories[i].isCurrent = true
                categories[i].childs[j].isCurrent = true
                categories[i].childs[j].childs[k].isCurrent = true
                categories[i].childs[j].childs[k].childs[l].isCurrent = true
                displayName = categories[i].name + ' > ' + categories[i].childs[j].name + ' > ' + categories[i].childs[j].childs[k].name + ' > ' + categories[i].childs[j].childs[k].childs[l].name
                isFound = true
                break
              }
            }

            if (isFound === true) {
              break
            }
          }
          if (isFound === true) {
            break
          }
        }
        if (isFound === true) {
          break
        }
      }

      return {
        displayName: displayName,
        categories: categories
      }
    }
  }
}

</script>
